
import React from 'react';
import { ArrowLeft, ArrowRight, Loader2, Star } from 'lucide-react';
import { Button } from '../shared';
import { Language } from '../../types';
import { translations } from '../../i18n';

interface LessonFooterProps {
  step: number;
  totalSteps: number;
  onPrev: () => void;
  onNext: () => void;
  onComplete: () => void;
  canGoNext: boolean;
  isQuiz: boolean;
  isWaitingForMore: boolean;
  quizCompleted: boolean;
  lang: Language;
  isDark: boolean;
}

export const LessonFooter: React.FC<LessonFooterProps> = ({ 
  step, totalSteps, onPrev, onNext, onComplete, canGoNext, isQuiz, isWaitingForMore, quizCompleted, lang, isDark 
}) => {
  const t = translations[lang];

  return (
    <div className={`p-6 sticky bottom-0 z-40 pt-10 bg-gradient-to-t ${isDark ? 'from-slate-950 via-slate-950/90' : 'from-white via-white/90'} to-transparent`}>
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-6">
        <button 
          onClick={onPrev} 
          disabled={step === 0} 
          className={`h-16 w-16 rounded-full flex items-center justify-center border-2 transition-all active:scale-95 ${
            step === 0 
            ? `cursor-not-allowed ${isDark ? 'border-white/5 text-white/20' : 'border-slate-200 text-slate-300'}` 
            : `${isDark ? 'border-white/20 text-white hover:bg-white/10' : 'border-slate-300 text-slate-600 hover:bg-slate-100'}`
          }`}
        >
          <ArrowLeft size={24}/> 
        </button>

        <div className="flex-1">
          {isQuiz ? (
            <Button 
              onClick={onComplete}
              disabled={!quizCompleted} 
              className={`w-full h-16 text-lg shadow-[0_0_30px_rgba(79,70,229,0.4)] bg-gradient-to-r from-indigo-600 to-violet-600 ${isDark ? 'border-t border-white/20' : ''}`}
            >
              <span className="mr-2">{t.completeMission}</span> <Star size={20} className="fill-yellow-400 text-yellow-400 animate-spin-slow"/>
            </Button>
          ) : (
            <Button 
              onClick={onNext}
              disabled={!canGoNext} 
              className={`w-full h-16 text-lg shadow-lg border-none ${
                !canGoNext 
                    ? `${isDark ? 'bg-slate-800/50 text-slate-500' : 'bg-slate-200 text-slate-400'} cursor-not-allowed` 
                    : `${isDark ? 'bg-white text-slate-900 hover:bg-indigo-50' : 'bg-slate-900 text-white hover:bg-slate-800'}`
              }`}
            >
              {isWaitingForMore ? (
                <><Loader2 size={20} className="animate-spin mr-2"/> <span className="text-sm">{t.generating}</span></>
              ) : (
                <><span className="mr-2">{t.next}</span> <ArrowRight size={20}/></>
              )}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
